import * as jsxRuntime from "/Users/rishubh/Desktop/ProvioHQ/providerhq/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment